// FLAGS: none
// The one owner of what "boot failed" means for the page: the static `#boot-loader` element that index.html
// paints until App commits, and the App Insights report. Dependency-light on purpose, so the error boundary and
// the entry point can import it without pulling the boot sequence in.
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { appInsights } from "@src/appInsights/AppInsights";

// Keeps the cover up over a pending reload, so the page never shows in the language it is leaving.
let heldForReload = false;

export const holdBootLoaderForReload = (): void => {
  heldForReload = true;
};

export const removeBootLoader = (): void => {
  if (heldForReload) {
    return;
  }
  document.getElementById("boot-loader")?.remove();
};

// Tagged `stage: "boot"` so a dashboard or alert can isolate boot failures from the rest of the exceptions.
export const BOOT_TELEMETRY_PROPERTIES = { stage: "boot" } as const;
// Tagged `stage: "resolve"` for the language-resolution miss trace, so one filter on `stage` covers the whole
// pre-React phase.
export const RESOLVE_TELEMETRY_PROPERTIES = { stage: "resolve" } as const;
// Tagged `stage: "switch"` for a picked language: the switch trace and a failed save of the pick.
export const SWITCH_TELEMETRY_PROPERTIES = { stage: "switch" } as const;

export const reportBootFailure = (error: unknown): void => {
  appInsights.trackException({
    exception: error as Error,
    severityLevel: SeverityLevel.Error,
    properties: { ...BOOT_TELEMETRY_PROPERTIES },
  });
};

// Report and stop showing the loader; the caller decides what, if anything, renders next.
export const failBoot = (error: unknown): void => {
  reportBootFailure(error);
  removeBootLoader();
};
